import 'babel-polyfill'
import Vue from 'vue'
import vuetify from './plugins/vuetify';

import { VApp, VTextField } from 'vuetify/lib'

import GlobalMixins from './mixins'
Vue.mixin(GlobalMixins);

import QPriceLookup from '@/components/q-price-lookup.vue'
import QMyCard from '@/components/q-my-card.vue'
import QDrugList from '@/components/q-drug-list.vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
    installComponents: true,
    load: {
        key: 'AIzaSyCyRoER5xjogwuJDFKLbC3GZV7Zw6OWc04',
        libraries: 'places',
    }
});

//Vue.config.productionTip = false

new Vue({
    el: '#glic-app',
    data: function() {
        return {}
    },
    vuetify,
    //render: function(h) { return h(App) }
    components: {
        QPriceLookup,
        VApp,
        QMyCard,
        QDrugList
    }
})

/*
new Vue({
    vuetify,
    render: h => h(QSample)
}).$mount('#glic-app')
*/